
import Slider from './Slider.js';
import { selectLangObj } from '../../reducers/langReducer.js';
import { useSelector } from 'react-redux';


function DocumentSlider({title, appendItems, getItems, moreElement }) {


  return (
    <Slider moreElement={moreElement} dynamic={false} title={title} onEnd={() => appendItems()} items={()=>getItems()}></Slider>
  );
}

export default DocumentSlider;
